import React from 'react';
import ContractMarkdown from '../components/ContractMarkdown';
import { POSITION_DESCRIPTION_MD, PD_VERSION } from '../lib/positionDescription';
import { COMPANY } from '../config/brand';

// Schedule A to the contract; linked from the contract and the signed-copy
// email, so it stays at this address.
const PositionDescription = () => (
  <section className="wc-container max-w-3xl py-12">
    <p className="wc-eyebrow">{COMPANY.legalName} · Schedule A</p>
    <div className="wc-card mt-4 p-6 sm:p-8">
      <ContractMarkdown markdown={POSITION_DESCRIPTION_MD} />
    </div>
    <p className="mt-3 text-xs text-muted">Version {PD_VERSION}</p>
  </section>
);

export default PositionDescription;
